/* eslint-disable react/prop-types */
import React, { Fragment } from "react"
import paginationFactory, { PaginationListStandalone, PaginationProvider } from "react-bootstrap-table2-paginator"

import BootstrapTable from "react-bootstrap-table-next"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  Container,
  CardText,
  Badge,
} from "reactstrap"
import * as moment from "moment";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
export const ModalTable = props => {
  const { betType, size, columns, data } = props
  console.log(data, 'oooo')
  // Table Data
  const pageOptions = {
    sizePerPage: 5,
    totalSize: data?.bets?.length ?? 0,
    custom: true,
  }

  const dateStr = data?.created_at?.replace(/\.\d+Z$/, "Z");
  const date = new Date(dateStr);

  const formattedDate = date.toLocaleDateString("en-GB");
  const formattedTime = date.toLocaleTimeString("en-GB");

  return (
    <Fragment>
      <Card>
        <div className="card-header bg-light border-bottom">
          <Row>
            <Col lg={3}>
              <Row>
                <Col lg={size == "xl" ? 4 : 6}>
                  <div className="card-title text-nowrap">Bet Type:</div>
                </Col>
                <Col lg={size == "xl" ? 8 : 6}>
                  <Badge className="me-2 bg-primary text-nowrap">
                    {data.bets?.length == 1 ? "Single" : "Multiple"}
                  </Badge>
                </Col>
              </Row>
            </Col>
            <Col lg={6}></Col>
            <Col lg={3}>
              <Row>
                <Col lg={4}>
                  <div className="card-title text-nowrap">Stake Tax:</div>
                </Col>
                <Col lg={6}>
                  <Badge className="me-2 bg-primary text-nowrap">
                    {data.excise_tax}
                  </Badge>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <Row>
                <Col lg={3}>
                  <div className="card-title text-nowrap">Log:</div>
                </Col>
                <Col lg={9}>
                  <Row>
                    <Col lg={12}>
                      <Badge pill className="badge-soft-dark me-1">
                        {" "}
                        {new Date(Date.parse(data?.created_at)).toLocaleDateString('en-GB')}{" "}
                        {new Date(Date.parse(data?.created_at)).toLocaleTimeString()}
                      </Badge>
                    </Col>
                  </Row>

                </Col>
                <Col lg={2}></Col>
              </Row>
            </Col>
            <Col lg={6}></Col>

            <Col lg={3}>
              <Row>
                <Col lg={4}>
                  <div className="card-title text-nowrap">WHT:</div>
                </Col>
                <Col lg={8}>
                  <Badge className="me-2 bg-primary text-nowrap">
                    {parseFloat(data?.wht)?.toFixed(2)}
                  </Badge>
                </Col>
              </Row>
            </Col>
            <Col lg={3}>

            </Col>
            <Col lg={6}></Col>
            <Col lg={3}>
              <Row>
                <Col lg={4}>
                  <div className="card-title text-nowrap">Total Odds:</div>
                </Col>
                <Col lg={8}>
                  <Badge className="me-2 bg-primary text-nowrap">
                    {parseFloat(data?.total_odds)?.toFixed(2)}
                  </Badge>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <CardBody>
          {
            data?.bets ?
              <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField="id"
                columns={columns}
                data={data?.bets}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <ToolkitProvider
                    keyField="id"
                    data={data?.bets}
                    columns={columns}
                    bootstrap4

                  >
                    {toolkitProps => (
                      <React.Fragment>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField="id"
                                responsive
                                bordered={false}
                                striped={false}

                                classes={
                                  "table align-middle table-nowrap table-check"
                                }

                                {...toolkitProps.baseProps}
                                {...paginationTableProps}

                                hover
                                rowClasses={"mytable-hover-row"}
                              />
                            </div>
                          </Col>
                        </Row>
                        <div className="pagination pagination-rounded justify-content-end">
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </React.Fragment>
                    )}
                  </ToolkitProvider>
                )}
              </PaginationProvider>
              : ''
          }


        </CardBody>
      </Card>
    </Fragment>
  )
}
